const plugin = require("tailwindcss/plugin");

/** @type {import('tailwindcss').Config} */
const config = {
  presets: [require("./preset")],
  content: ["./public/index.html", "./src/**/*.{js,jsx,ts,tsx}"],
  plugins: [
    require("@tailwindcss/container-queries"),
    require("./plugins/basePlugin"),
    require("./plugins/typography"),
    require("./plugins/ripplePlugin"),
    plugin(function ({ addUtilities }) {
      addUtilities({
        ".h-fill-available": {
          height: "100vh",
        },
        ".max-h-fill-available": {
          maxHeight: "100vh",
        },
        '.no-scrollbar::-webkit-scrollbar': {
          display: 'none'
        },
        '.no-scrollbar': {
          '-ms-overflow-style': 'none',
          'scrollbar-width': 'none'
        },
      });
    }),
  ],
};

module.exports = config;
